import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'
import MainContent from '../../components/layouts/MainContent'
import MainMenu from '../../components/layouts/MainMenu'

/**
 * UserManagement Component
 *
 * Main page component for Client Admin user management interface.
 * This component serves as the navigation target for the role-based
 * "User Management" menu option available exclusively to Client Admin users.
 *
 * Features:
 * - Client Admin access control using CEM feature flags
 * - Integration with UserManagementLayout for full functionality
 * - Comprehensive user management interface with filtering and search
 * - Empty state handling when no users exist in the system
 * - Localized content using react-i18next
 * - Sets document title on component mount
 * - Follows established ECP page architecture patterns
 */
const UserManagement = () => {
  const { t } = useTranslation()

  // Set document title on component mount following ECP page pattern
  useEffect(() => {
    document.title = t('ECPUserManagementTitle', 'User Management - myRSM')
  }, [t])

  // Render UserManagementLayout which orchestrates the entire User Management interface
  return (
    <>
      <MainMenu currentItem="userManagement" />
      <MainContent>
        <Outlet />
      </MainContent>
    </>
  )
}

export default UserManagement
